module.exports = __webpack_public_path__ + "img/taptab-logo.0abb69e0.png";